import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { Button, Container, Row, Col } from 'react-bootstrap';

import DocMeta from 'components/DocMeta';
import List from 'components/List';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';

class ApiDoc extends React.Component {
  render() {
    const { intl, appIntl, list } = this.props;
    const messages = intl.messages;

    const tags = [
      //      {name: 'title', content: messages.meta.api_doc.title},
      //      {name: 'description', content: messages.meta.api_doc.description},
      //      {itemProp: 'name', content: messages.meta.api_doc.name},
      //      {itemProp: 'description', content: messages.meta.api_doc.description},
      //      {itemProp: 'image', content: "http://www.example.com/image.jpg"}
    ];

    return (
      <DocMeta tags={tags}>
        <div className="content">
          <List listName="apiDocGroups" url="/api/documentation/groups.json" list={list} noRender />

          {!list.pending ? (
            <div className="padding-25 sm-padding-10">
              <Breadcrumb
                crumbs={[{ link: appIntl.urlPrefix, name: 'Creacheck' }, { link: null, name: 'Documentation' }]}
              />

              <Container fluid>
                <Row>
                  <Col md={3} className="bg-master-lighter p-b-25">
                    <h1>Groups</h1>

                    {list.data.list.map((groupId, i) => {
                      return (
                        <div key={i} className="m-b-5">
                          <Link to={appIntl.urlPrefix + 'docs/' + groupId}>{groupId}</Link>
                        </div>
                      );
                    })}
                  </Col>
                  <Col md={9}>
                    <h1>API docs</h1>
                  </Col>
                </Row>
              </Container>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    appIntl: state.intl,
    list: state.list.apiDocGroups,
  };
};

export default legacyInjectIntl(connect(mapStateToProps)(ApiDoc));
